import { render } from "./LedgerAccountsView.vue?vue&type=template&id=c05d2b1a"
import script from "./LedgerAccountsView.vue?vue&type=script&lang=js"
export * from "./LedgerAccountsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__